module.exports = __webpack_public_path__ + "img/successful.f6d1cbf9.png";